// Calcoli dei preventivi: nel database i prezzi unitari sono sempre IVA inclusa (il backend scorpora l'imponibile).
// Nel form si puo' scegliere di digitare prezzi netti: vengono portati a IVA inclusa prima del salvataggio.

export const CONDIZIONI_PAGAMENTO = [
  { id: 'ACCONTO', label: 'Acconto alla conferma' },
  { id: 'SALDO_CONSEGNA', label: 'Saldo alla consegna' },
  { id: 'BONIFICO', label: 'Bonifico bancario' },
  { id: 'CONTANTI', label: 'Contanti' },
  { id: 'CARTA', label: 'Carta / POS' },
];

export const round = (n, decimali = 2) => {
  const f = 10 ** decimali;
  return Math.round((n + Number.EPSILON) * f) / f;
};

// Prezzo unitario IVA inclusa, partendo da quello digitato nel form
export const lordoUnitario = (prezzo, iva, prezziIvati) =>
  prezziIvati ? (prezzo || 0) : round((prezzo || 0) * (1 + (iva || 0) / 100), 2);

export const nettoDaLordo = (lordo, iva) => ((iva || 0) > 0 ? round((lordo || 0) / (1 + iva / 100), 4) : (lordo || 0));

export const calcolaTotali = (dettagli, prezziIvati) => {
  let subtotale = 0;
  let ivaTotale = 0;
  dettagli.forEach(item => {
    const lordoRiga = lordoUnitario(item.prezzo_unitario, item.iva_percentuale, prezziIvati) * item.quantita;
    const imponibileRiga = item.iva_percentuale > 0 ? lordoRiga / (1 + item.iva_percentuale / 100) : lordoRiga;
    subtotale += imponibileRiga;
    ivaTotale += lordoRiga - imponibileRiga;
  });
  return { subtotale, iva_totale: ivaTotale, totale: subtotale + ivaTotale };
};

// Stessa regola del backend: l'importo ha la precedenza sulla percentuale
export const calcolaAcconto = (totale, accontoPercentuale, accontoImporto) => {
  const importo = parseFloat(accontoImporto);
  const percentuale = parseFloat(accontoPercentuale);
  let valore = null;
  if (importo > 0) valore = importo;
  else if (percentuale > 0) valore = (totale * percentuale) / 100;
  if (valore === null) return null;
  return round(Math.min(valore, totale), 2);
};
